module.exports = __webpack_public_path__ + "media/images/Grey Cabinets Crown Molding sq-104a30e0.webp";